export const PridobivanjeZgodovineNarocil = {
  methods: {
    GetZgodovinaNarocil (prenosniParam) {
      if (prenosniParam.prenesenIzbranId !== '' && prenosniParam.samoPomembno !== '') {
        let param = ['idStranka=' + prenosniParam.prenesenIzbranId]
        param.push('samoPomembno=' + prenosniParam.samoPomembno)
        this.clientAgent.postWsRequest(this,
          'klub/narocila/pridobiZgodovinoNarocil?',
          param,
          prenosniParam,
          'SetZgodovinaNarocil',
          'ErrZgodovinaNarocil')
      }
    },
    SetZgodovinaNarocil (podatki, prenosniParam) {
      let podatkiZgodovineNarocil = podatki.data
      let vmesnik = prenosniParam.vmesnik
      vmesnik.PridobiPodatkeZgodovineNarocilKlub(prenosniParam, podatkiZgodovineNarocil)
    },
    ErrZgodovinaNarocil (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/Klub/PridobivanjeZgodovineNarocil.js